function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "28",
  viewBox: "0 0 32 28"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: ".9",
  d: "M9.402 1.012c2.233.117 4.48 1.077 6.243 2.818l.356.35.356-.35c3.527-3.481 9.06-3.827 12.357-.572 3.299 3.256 2.957 8.725-.57 12.207l-1.129 1.112-10.237 10.108a1.11 1.11 0 01-1.55 0L4.988 16.577 3.86 15.465C.332 11.983-.015 6.515 3.284 3.258 4.932 1.631 7.17.896 9.402 1.012z"
})));